import React from 'react'
import "./NavbarN.css"
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from "../../assets/logo1.png";
import Home from '../Home/Home';

const NavbarN = () => {
  return (
       <div className='i1'>
      <Navbar bg="light" expand="lg" variant='light'>
      <Container >
        <Navbar.Brand href=""><img src={logo} alt='logo' width='40px' style={{color:"darkgray"}}/></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="N">
            <Nav.Link href="#" className='n-li'><strong >Home</strong></Nav.Link>
            <Nav.Link href="#" className='n-li'><strong>About Us</strong></Nav.Link>
            <Nav.Link href="#" className='n-li'><strong>Internship</strong></Nav.Link>
            <Nav.Link href="#" className='n-li'><strong>Our Youth</strong></Nav.Link>
            <Nav.Link href="#" className='n-li'><strong>Program</strong></Nav.Link>
            <Nav.Link href="#" className='n-li'><strong>Contact Us</strong></Nav.Link>
            <Nav.Link href="#" className='n-li'><strong>Login</strong></Nav.Link>
            
          </Nav>
          {/* <img src={images} alt="search" width="25" className='search-icon' style={{color:"white",backgroundColor: "#343a40"}}/> */}
              <i class="far fa-search" style={{color:"white"}}></i>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <Home/>
    </div>
  )
}

export default NavbarN
